import React from 'react'

interface CustomLegendProps {
  labels: string[]
  colors: string[]
  itemsPerRow?: number
}

const CustomLegend: React.FC<CustomLegendProps> = ({
  labels,
  colors,
  itemsPerRow = 2,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        margin: 'auto',
        width: '100%',
      }}
    >
      {labels.map((label, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            gap: '5px',
            width: `calc(100% / ${itemsPerRow} - 10px)`,
          }}
        >
          <span
            style={{
              display: 'inline-block',
              width: '12px',
              height: '12px',
              backgroundColor: colors[index],
              borderRadius: '2px',
              flexShrink: 0, // Prevents shrinking
              minWidth: '12px', // Ensures it remains the same width
              marginTop: '3px',
            }}
          ></span>
          <span
            className="text-start"
            style={{
              fontSize: '12px',
              color: '#4A5568',
              width: '150px',
              flexGrow: 1,
              display: 'flex',
              alignItems: 'center',
              lineHeight: '1.2',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            {label}
          </span>
        </div>
      ))}
    </div>
  )
}

export default CustomLegend
